import { useEffect, useRef, useState } from 'preact/hooks';
import { getDailyHunts, requestDailyHunts, subscribeDailyHunts } from '@/daily-hunts';
import { Button } from '@/ui/components';
import { UI_ITEM_BG, UI_PANEL_BORDER } from '@/ui/consts';
import { useClient } from '@/ui/context';
import { DialogBase } from './dialog-base';

export function DailyHuntsDialog(){
 const client=useClient();const [state,setState]=useState(()=>getDailyHunts(client));
 const interacting=useRef(false);
 useEffect(()=>{
  const unsubscribe=subscribeDailyHunts(client,()=>setState(getDailyHunts(client)));
  // Opening the panel stops an already queued approach/attack. UI taps never enqueue movement.
  client.npcController.cancelAutoAttack();client.movementController.autoWalkPath=[];
  requestDailyHunts(client);
  const timer=window.setInterval(()=>{if(!document.hidden&&!interacting.current)requestDailyHunts(client);},5000);
  const release=()=>{interacting.current=false;};window.addEventListener('pointerup',release);window.addEventListener('pointercancel',release);
  return ()=>{unsubscribe();clearInterval(timer);window.removeEventListener('pointerup',release);window.removeEventListener('pointercancel',release);};
 },[client]);
 const snapshot=state.snapshot;
 useEffect(()=>{
  const refresh=()=>{if(!document.hidden&&!interacting.current)requestDailyHunts(client);};
  const reset=Date.parse(snapshot?.reset_at??'');
  const timer=Number.isFinite(reset)&&reset>Date.now()?window.setTimeout(refresh,Math.min(2147483647,reset-Date.now()+100)):undefined;
  window.addEventListener('focus',refresh);document.addEventListener('visibilitychange',refresh);
  return()=>{if(timer!==undefined)clearTimeout(timer);window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh);};
 },[client,snapshot?.reset_at]);
 return <DialogBase id='hunts' title='Daily Hunts' size='md' avoidBottom touchScroll>
  <div data-daily-hunts class='space-y-3 p-2 text-sm' style={{height:'min(60dvh,520px)',overflowY:'auto'}} onPointerDownCapture={()=>{interacting.current=true;}} onPointerUp={()=>{interacting.current=false;}} onPointerCancel={()=>{interacting.current=false;}}>
   <p role='status' aria-live='polite'>{state.message||(!snapshot?'Loading hunts…':'')}</p>
   {snapshot&&<>
    <p>{snapshot.hunts.filter(h=>h.claimed).length}/5 rewards claimed today. Five hunts refresh automatically each day. Next reset: {new Date(snapshot.reset_at).toLocaleString()}.</p>
    {!snapshot.enabled&&<p>Daily Hunts are paused. Your progress is saved.</p>}
    {snapshot.hunts.map(h=><section key={`${snapshot.reset_at}:${h.slot}`} data-hunt-slot={h.slot} class={`hunt-card space-y-2 rounded border ${UI_PANEL_BORDER} ${UI_ITEM_BG} p-3`}>
     <h3 class='font-semibold'>{h.name}</h3>
     <p>{h.npc_name}: {h.progress}/{h.target}</p>
     <progress class='progress progress-primary w-full' max={h.target} value={h.progress}/>
     <p>{h.experience.toLocaleString()} EXP + {h.item_amount} × {h.item_name}</p>
     <Button variant={['sm','primary']} class='min-h-11 w-full' disabled={state.pending||!snapshot.enabled||h.claimed||h.progress<h.target} onClick={()=>requestDailyHunts(client,h.slot)}>
      {h.claimed?'Claimed':h.progress>=h.target?'Claim reward':'Hunt in progress'}
     </Button>
    </section>)}
   </>}
   <Button variant='sm' class='min-h-11 w-full' disabled={state.pending} onClick={()=>requestDailyHunts(client)}>Refresh</Button>
  </div>
 </DialogBase>;
}
